import React, {useContext, useEffect} from "react";
import { CheckingLogin } from "./AuthMessages";
import {getAuthenticationContext} from "../../auth/AuthenticationContext";

interface AuthenticationWrapperProps {
  children: React.ReactElement;
}

export const AuthenticationWrapper = ({
  children,
}: AuthenticationWrapperProps) => {
  const AuthenticationContext = useContext(getAuthenticationContext());
  const [isUserloggedIn, setLoggedIn] = React.useState(false);
  const [authenticationError, setAuthenticationError] = React.useState(false);

  useEffect(() => {
    AuthenticationContext.checkUserLoggedIn()
      .then(() => {
        setLoggedIn(true);
      })
      .catch(() => {
        try {
          AuthenticationContext.redirectToLogin();
        } catch (e) {
          console.log("Failed to redirect user to login: " + e);
          setAuthenticationError(true);
        }
      });
  }, [AuthenticationContext]);

  return isUserloggedIn ? children : <CheckingLogin error={authenticationError}/>;
};
